import React from 'react';
// eslint-disable-next-line no-restricted-imports -- TODO: legacy styled-components (baseline)
import styled from 'styled-components/macro';

const Bars = styled.div`
    width: ${props => props.boxWidth}px;
    height: ${props => props.boxHeight}px;

    border-radius: ${props => props.boxHeight}px;

    background-color: ${props => (props.hamburgerIsActive ? 'transparent' : props.accentColor)};
    transform: translate(0, ${props => props.boxHeight + props.gap}px);

    transition: background-color ${props => props.animation}ms;

    &:before,
    &:after {
        display: block;

        border-bottom: ${props => props.boxHeight}px solid ${props => props.accentColor};
        border-radius: ${props => props.boxHeight}px;

        transform: translate(0, ${props => props.boxHeight / 2}px);

        transition: transform ${props => props.animation}ms;
        content: '';
    }

    &:before {
        transform: ${props =>
            props.hamburgerIsActive ? `rotate(-45deg)` : `translate(0, -${props.gap + props.boxHeight}px)`};
    }

    &:after {
        transform: ${props =>
            props.hamburgerIsActive
                ? `translate(0, -${props.boxHeight}px) rotate(45deg)`
                : `translate(0, ${props.gap}px)`};
    }
`;

const Container = styled.div`
    width: ${props => props.boxWidth}px;
    height: ${props => props.boxHeight}px;

    background-color: transparent;
    cursor: ${props => props.cursorType || 'pointer'};
`;

const Hamburger = ({
    animation = 250,
    height = 3,
    width = 28,
    gap = 5,
    color = 'black',
    hamburgerIsActive,
    ...rest
}) => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <Container boxWidth={width} boxHeight={3 * height + 2 * gap} {...rest}>
        <Bars
            accentColor={color}
            animation={animation}
            boxHeight={height}
            boxWidth={width}
            gap={gap}
            hamburgerIsActive={hamburgerIsActive}
        />
    </Container>
);

export default Hamburger;
